
import { Fragment } from "vue-frag";
import axios from "axios";
import { debounce } from "lodash";
import check from "~/store/elementChecker";
const fetchItems = (route, params) => {
  if ((Object.keys(route.query) || []).length || !route.params.path) {
    return true;
  }
  return (
    (Object.keys(params) || []).filter((x) => params[x]).length > 1 ||
    (Object.keys(params) || [])[0] != "business_activity"
  );
};
let lock = false;
let itemMethod = async ({ req, app, params, store, route, redirect,error }) => {
  let head;
  try {
    await store.commit("itemReady", false);
    let host = "";
    if (process.server) {
      host = req.headers.host + route.fullPath;
    } else {
      host = location.host + route.fullPath;
    }
    host = encodeURIComponent(host);
    let temp = {};
    let item = {};
    let id = (params.id || "").split("+")[0];
    try {
      if (params.id.split("----")[1]) {
        id = params.id.split("---")[0].split("+")[0];
      } else if (params.id.split("---")[1]) {
        id = params.id.split("---")[1];
      } else if (params.id.split("--")[1]) {
        id = params.id.split("--")[1];
      }
    } catch (error) {
      console.error(error);
    }
    let url = `${process.env.axiosUrl}/items/sv/store/${
      store.state.store.store_id
    }?store_id=${store.state.store.store_id}&direct=true&q=${encodeURIComponent(
      id
    )}`;
    try {
      temp = await axios.get(url, {
        headers: {
          shopster: host,
          Authorization: `Bearer ${store.state.token}`,
        },
      });
    } catch (e) {
      console.error(e);
      return { item };
    }
    if (!item || !(((temp.data || {}).items || {}).docs || []).length) {
      let failed = { failed: true };
      await store.commit("item", undefined);
      return error({ statusCode: 404, message: 'Δεν βρέθηκε το προϊόν' })
      return { failed };
    }
    let tp = await app.$hyperItem.prepareItems((temp.data.items || {}).docs);
    item = (tp || [])[0];
    try{
      let p=route.params.path.split("/");
      try {
        if (route.params.path.includes("/product/")) {
          let extrap = route.params.path.split("/product/")[1].split("/")?.length;
          if(extrap>1){
            return error({ statusCode: 404, message: "Δεν βρέθηκε το προϊόν" });
          }
        }
      } catch (e) {}
      p = p.slice(0,p.indexOf("product"));
      if(p[0] && p[0] != app.$hyperUtility.slugifyGreek(item.business_activity||'')){
        return error({ statusCode: 404, message: 'Δεν βρέθηκε το προϊόν' })
      }
      if(p[1] && p[1] != app.$hyperUtility.slugifyGreek(item.family||'')){
        return error({ statusCode: 404, message: 'Δεν βρέθηκε το προϊόν' })
      }
      if(p[2] && p[2] != app.$hyperUtility.slugifyGreek(item.subfamily||'')){
        return error({ statusCode: 404, message: 'Δεν βρέθηκε το προϊόν' })
      }
      if(p[3] && p[3] != app.$hyperUtility.slugifyGreek(item.category||'')){
        return error({ statusCode: 404, message: 'Δεν βρέθηκε το προϊόν' })
      }
    }catch(e){
      console.log(e);
    }
    if (
      !route.path.includes("--") &&
      !route.path.includes("+") &&
      !route.path.includes("%2B")
    ) {
      return redirect(
        301,
        `${(route.fullPath || "").split("?")[0]}+${encodeURIComponent(
          app.$hyperUtility.greekIfy(item.page_title || item.description)
        )}?${(route.fullPath || "").split("?")[1] || ""}`
      );
    }
    let preview = "";
    if (app.$cookies.get("preview")) {
      let pr = (app.$cookies.get("preview") || "").split(":::");
      if (pr[1] == store.getters.store.id) {
        preview = `&preview=${pr[0]}`;
      }
    }
    store.commit("item", item);
    store.commit("itemReady", true);
    store.commit("history", { type: "item", item });
    try {
      let res = await axios.get(
        `${process.env.axiosUrl}/stores/${
          store.getters.store.id
        }?elements=item&build=${
          (store.getters.store.build || {}).build_no
        }&&styleless=true&elementsonly=true${preview}`,
        {
          headers: {
            shopster: host,
          },
        }
      );
      if ((res.data || {}).id) {
        await store.dispatch("prepareElements", {
          state: store.state,
          item: item,
          elements: [
            ...store.getters.store.eshop.elements.filter((e) => e.static),
            ...res.data.eshop.elements,
          ],
          app,
        });
      }
    } catch (e) {
      console.error(e);
    }

    {
      head = {
        title: (store.getters.item || {}).page_title
          ? store.getters.item.page_title
          : `${store.getters.item?.description || "Καταργήθηκε"} - ${
              store.getters.store.name
            }`,
        meta: [...app.$hyperSeo.meta(), ...app.$hyperSeo.og()],
        script: [{
          hid: "ldItem",
          type: "application/ld+json",
          json: app.$hyperSeo.schemas(
            "item",
            store.getters.item,
            route
          ),
        },{
          hid: "ldBreadcrumbItem",
          type: "application/ld+json",
          json: app.$hyperSeo.schemas(
            "breadcrumbItem",
            store.getters.item,
            route
          ),
        }],
      };
    }
    return { item, head };
  } catch (error) {
    console.error(error);
    await store.commit("itemReady", true);
    let failed = { failed: true };
    return { failed };
  }
};
let dataMethod = async ({
  app,
  req,
  route,
  commit,
  store,
  redirect,
  silent,
  error,
}) => {
  let host = "";
  if (process.server) {
    host = req.headers.host + route.fullPath;
  } else {
    host = location.host + route.fullPath;
  }
  if (store.getters.isBackButton) {
    store.commit("isBackButton", false);
    return {};
  }
  let page = 1,
    pages = 0,
    limit = 16,
    total = 0,
    pagination = [],
    items = [],
    filters = {
      business_activity: "",
      manufacturer: "",
      family: "",
      subfamily: "",
      category: "",
      q: "",
      limit: 16,
      page: 1,
      pages: 1,
      sorting: {},
    };
  let params = {};
  let occupied = [];
  if (!route.params.path && !route.query) {
    redirect(301, "/");
  }
  let path = (route.params.path || "").split("/");
  path.forEach((p, index) => {
    if (p.includes("m.")) {
      params.manufacturer = p.replace("m.", "");
      occupied.push(index);
    } else if (p.includes("ba.")) {
      params.business_activity = p.replace("ba.", "");
      occupied.push(index);
    } else if (p.includes("fa.")) {
      params.family = p.replace("fa.", "");
      occupied.push(index);
    } else if (p.includes("sf.")) {
      params.subfamily = p.replace("sf.", "");
      occupied.push(index);
    } else if (p.includes("ca.")) {
      params.category = p.replace("ca.", "");
      occupied.push(index);
    } else if (p.includes("tag.")) {
      let parts = p.split(".");
      params[`tag.${parts[1]}`] = parts[2];
      occupied.push(index);
    }
    if (!occupied.includes(index) && !params.business_activity) {
      params.business_activity = p;
    } else if (!occupied.includes(index) && !params.family) {
      params.family = p;
    } else if (!occupied.includes(index) && !params.subfamily) {
      params.subfamily = p;
    } else if (!occupied.includes(index) && !params.category) {
      params.category = p;
    } else if (!occupied.includes(index) && !params.manufacturer) {
      params.manufacturer = p;
    }
  });
  let combined_params = { ...params, ...route.query };
  combined_params = app.$hyperUtility.acceptedParams(combined_params);
  store.commit("params", params);
  let search = [];
  if (
    !combined_params.orderby &&
    !combined_params.q &&
    store.state.store.eshop.sorting[0]
  ) {
    let sorting = store.state.store.eshop.sorting[0] || {};
    filters.sorting = sorting;
    filters.orderby = ((sorting.value || "").split("+") || {})
      .filter((x) => x)[0]
      .split("=")[1];
    filters.order = ((sorting.value || "").split("+") || {})
      .filter((x) => x)[1]
      .split("=")[1];
    combined_params.orderby = ((sorting.value || "").split("+") || {})
      .filter((x) => x)[0]
      .split("=")[1];
    combined_params.order = ((sorting.value || "").split("+") || {})
      .filter((x) => x)[1]
      .split("=")[1];
  }
  let useFullParams = [];
  Object.keys(combined_params)
    .filter((k) => combined_params[k] != "-" && combined_params[k])
    .forEach((k) => {
      if (combined_params[k] && combined_params[k] != "-") {
        let cp = combined_params[k];
        if(!['limit','page','orderby','order'].includes(k) && cp){
                  useFullParams.push(k);
        }
        if (Array.isArray(cp)) {
          cp = [...new Set(cp)].join(",");
        }
        k = encodeURIComponent(k);
        search.push(`${k}=${encodeURIComponent(cp)}`);
      }
    });
  search = search.filter((x) => x).join("&");
  if(!useFullParams.length && route.params.path){
    redirect(301,`/${store.getters.store.eshop.catalogRoute}`);
  }
  // store.commit("sidePanel", {});

  if (
    (store.getters.store.eshop || {}).limit &&
    !(search + "").includes("limit")
  ) {
    filters.limit = store.getters.store.eshop.limit;
    if (!fetchItems(route, params)) {
      search += `&limit=1`;
    } else {
      search += `&limit=${filters.limit}`;
    }
  }
  // if(store.getters.store.eshop.searchReplicate){
  //   search += `&fields=${store.getters.store.eshop.searchReplicate}`
  // }

  try {
    let projectAgora = store.getters.store.flat_plugins["Project Agora"]?.on;
    let temp = await axios.get(
      `${process.env.axiosUrl}/items/sv/store/${store.state.store.store_id}?store_id=${store.state.store.store_id}&fullProductPath=${store.state.store.eshop.fullProductPath}&catalogRoute=${store.state.store.eshop.catalogRoute}&${search}&exclude=comment&aliases=true&projectAgora=${projectAgora}`,
      {
        headers: {
          shopster: host,
          Authorization: `Bearer ${store.state.token}`,
        },
      }
    );
    temp = (temp || {}).data;
    if (temp) {
       if(temp.items && temp.items.docs && !temp.items.docs.length){
         // #23177 follow-up (2026-07-27): only 404 an empty listing when it is
         // NOT a curated landing page. A curated page whose products are all
         // temporarily disabled/out of stock must keep returning 200, or Google
         // drops it from the index and it stops working as an ad destination.
         // Same curated test as the #23102 noindex block below.
         let curated = false;
         try {
           await app.$cms.get({
             title: "listing_page_seo",
             store_id: store.getters.store.id,
             match_url_exact: route.path,
             limit: 1,
           });
           curated = (store.getters.cms.listing_page_seo || []).some(
             (d) => d && d.match_url === route.path
           );
         } catch (e) {}
         if (!curated) {
           error({ statusCode: 404, message: 'Δεν βρέθηκαν αποτελέσματα' })
         }
       }
      items = await app.$hyperItem.prepareItems(
        ((temp || {}).items || []).docs || []
      );

      filters.page = temp.items.page;
      filters.pages = temp.items.pages;
      filters.total = temp.items.total;
      if (store.state.filters.sorting) {
        filters.sorting = store.state.filters.sorting || {};
      }
      let full_combined = { ...filters, ...params, ...route.query };
      full_combined = app.$hyperUtility.acceptedParams(full_combined);

      if (full_combined.orderby) {
        full_combined.sorting =
          store.state.store.eshop.sorting.find(
            (s) =>
              s.value.includes(full_combined.orderby) &&
              s.value.includes(full_combined.order)
          ) || "";
      } else {
        full_combined.sorting = {};
      }
      for (const k of [
        "business_activity",
        "family",
        "manufacturer",
        "subfamily",
        "category",
      ]) {
        if (full_combined[k]) {
          let combines = (full_combined[k] || "").split("_or_");
          let propers = [];
          let propers_slug = [];
          let alias = temp.aliases[k];
          combines.forEach((c) => {
            let proper = alias?.find(
              (a) =>
                app.$hyperUtility.slugifyGreek(a) ==
                app.$hyperUtility.slugifyGreek(c)
            );
            if (proper) {
              propers.push(proper);
              propers_slug.push(app.$hyperUtility.slugifyGreek(proper));
            }
          });
          full_combined[k] = propers.join("_or_");
          full_combined[`${k}_slug`] = propers_slug.join("_or_");
        }
      }
      Object.keys(full_combined)
        .filter(
          (k) =>
            ![
              "business_activity",
              "family",
              "manufacturer",
              "subfamily",
              "category",
              "page",
              "limit",
              "orderby",
              "order",
              "pages",
            ].includes(k) || k.includes("tag.")
        )
        .forEach((k) => {
          (full_combined[k] + "").split("_or_").forEach((v) => {
            let proper = items.find((i) =>
              i.tags.find(
                (t) => t.key_slug == k.replace("tag.", "") && t.value_slug == v
              )
            );
            if (proper) {
              let tag = proper.tags.find(
                (t) => t.key_slug == k.replace("tag.", "") && t.value_slug == v
              );
              if (tag) {
                store.commit("filterLabels", {
                  key: k.replace("tag.", ""),
                  value: tag.key,
                });
                store.commit("filterLabels", {
                  key: tag.value_slug,
                  value: tag.value,
                });
                // full_combined[`tag.${tag.key}`] = tag.value;
                // full_combined[`${k}_slug`] = tag.value_slug;
                // delete full_combined[k];
              }
            }
          });
        });
      store.commit("filters", full_combined);
      await store.dispatch("filters");
      pagination = [];
      for (let i = 1; i <= temp.items.pages; i++) {
        if (i == 1) {
          pagination.push(i);
        }
        if (
          i > temp.items.page - 3 &&
          i < temp.items.page + 3 &&
          i > 1 &&
          i < temp.items.pages
        ) {
          pagination.push(i);
        }
        if (i == temp.items.pages) {
          pagination.push(i);
        }
      }
      pagination = [...new Set(pagination)];
    }
    let preview = "";
    if (app.$cookies.get("preview")) {
      let pr = (app.$cookies.get("preview") || "").split(":::");
      if (pr[1] == store.getters.store.id) {
        preview = `&preview=${pr[0]}`;
      }
    }
    try {
      let res = await axios.get(
        `${process.env.axiosUrl}/stores/${
          store.getters.store.id
        }?elements=search&build=${
          (store.getters.store.build || {}).build_no
        }&&styleless=true&elementsonly=true${preview}`,
        {
          headers: {
            shopster: host,
          },
        }
      );
      if ((res.data || {}).id) {
        let elements = [
          ...store.getters.store.eshop.elements.filter((e) => e.static),
          ...((await app.$hyperElement.populateData({
            elements: res.data.eshop.elements,
            page: "search",
            app,
          })) || []),
        ];
        store.commit("elements", elements);
      }
    } catch (e) {
      console.error(e);
    }

    store.commit("pagination", pagination);
    if (!fetchItems(route, params)) {
      store.commit("items", []);
    } else {
      store.commit("items", items);
    }
  } catch (error) {
    console.error(error);
  }
  store.commit("item", { prices: {}, images: [] });

  let property = "";
  if (store.getters.filters.subfamily) {
    property = "subfamily";
  } else if (store.getters.filters.family) {
    property = "family";
  } else if (store.getters.filters.business_activity) {
    property = "business_activity";
  } else if (store.getters.filters.manufacturer) {
    property = "manufacturer";
  } else if (store.getters.filters["tag.anagki"]) {
    property = "tag.anagki";
  }

  if (!store.getters.filters[property]) {
    let tags =
      Object.keys(store.getters.filters).filter((k) => k.includes("tag.")) ||
      [];
    if (tags[0]) {
      property = tags[0];
    }
  }
  //CMS META INFO
  if (store.getters.filters[property]) {
    await app.$cms.get({
      title: "categories",
      store_id: store.getters.store.id,
      limit: 1000,
      property: property.replace(".", "__"),
      q:
        store.getters.filterLabels[store.getters.filters[property]] ||
        store.getters.filters[property],
    });
  }
  // #22057 — per-listing SEO by exact match_url (awaited so head() has it at SSR)
  try {
    await app.$cms.get({
      title: "listing_page_seo",
      store_id: store.getters.store.id,
      match_url_exact: route.path,
      limit: 1,
    });
  } catch (e) {}
  lock = false;
  store.commit("sub", {
    page,
    pages,
    limit,
    total,
    search,
  });
  let title, description;
  let fromCms = store.getters.cms.categories;
  try {
    fromCms = fromCms.find(
      (f) =>
        f.business_activity == store.getters.filters.business_activity &&
        (f.family || "") == (store.getters.filters.family || "") &&
        (f.subfamily || "") == (store.getters.filters.subfamily || "")
    );
    title = fromCms.title;
    description = fromCms.description;
  } catch (error) {
    title = titleCreator(store, route.query, store.getters.params);
    description = `${store.getters.filters.business_activity || ""} ${
      store.getters.filters.family || ""
    } ${store.getters.filters.subfamily || ""} ${
      store.getters.filters.category || ""
    }`;
  }
  // #22057 — per-listing SEO override (exact match_url) wins over category/auto
  let seo = (store.getters.cms.listing_page_seo || []).find(
    (d) => d && d.match_url === route.path
  );
  if (seo && seo.title_tag) title = seo.title_tag;
  if (seo && seo.meta_description) description = seo.meta_description;
  // #23102 — noindex,follow every filter-combination listing except the curated whitelist.
  // The whitelist IS the set of pages that received curated SEO in #22057 (a listing_page_seo doc
  // for the exact match_url). A "filter combination" is a catalog path carrying a manufacturer (m.)
  // or tag (tag.) facet segment, and/or a narrowing query-param filter. Such a page stays indexable
  // ONLY when it is whitelisted AND carries no extra query-param filter; otherwise noindex,follow.
  // Plain taxonomy category pages and the generic guards in hyperSeo.meta (pagination, _or_, ?q)
  // are unchanged.
  const _seoPath = route.path || "";
  const _seoQuery = route.query || {};
  // A brand landing page (/catalog/m.<brand>) is NOT a filter combination: it
  // is one top-level facet over a finite set (703 manufacturers) and it was
  // indexable before #23102. What this gate exists to suppress is the
  // combinatorial space — category x brand, brand x tag, stacked tags — which
  // stays gated. Without this, m.frezyderm was indexable (it happens to be one
  // of only 4 brand-root whitelist entries) while m.apivita and m.korres were
  // not (#23102, reopened 2026-08-24).
  const _isBrandRoot = /^\/catalog\/m\.[^/]+\/?$/.test(_seoPath);
  const _hasPathFacet =
    !_isBrandRoot &&
    _seoPath
      .split("/")
      .some((s) => s.startsWith("m.") || s.startsWith("tag."));
  const _FILTER_QUERY_KEYS = ["manufacturer", "persons", "weight", "price", "rating", "vat", "stock", "tags", "sorting"];
  const _hasFilterQuery = Object.keys(_seoQuery).some((k) => _FILTER_QUERY_KEYS.includes(k));
  const _metaOverrides = { description };
  if ((_hasPathFacet || _hasFilterQuery) && !(seo && !_hasFilterQuery)) {
    _metaOverrides.robots = "noindex,follow";
  }
  let head = {
    title,
    link: [],
    meta: [
      ...app.$hyperSeo.meta(_metaOverrides),
      ...app.$hyperSeo.og({
      "og:title": title,
        "og:description": description,
      }),
    ],
    script: [
      {
        hid: "ldBreadcrumb",
        type: "application/ld+json",
        json: app.$hyperSeo.schemas(
          "breadcrumbFilters",
          store.getters.filters,
          route
        ),
      },
      {
        hid: "ldBreadcrumb",
        type: "application/ld+json",
        json: app.$hyperSeo.schemas(
          "itemList",
          store.getters.items,
          route
        ),
      },
    ],
  };
  let item = { prices: {}, images: [] };
  if (process.browser) {
    $nuxt.$emit("headUpdate", head);
  }
  return { head, item };
};
const titleCreator = (store, queries, params) => {
  let keys = [
    "q",
    "manufacturer",
    "tags",
    "category",
    "subfamily",
    "family",
    "business_activity",
  ];
  let all = { ...queries, ...params };
  //remove &&0 from :620 skiparei ta tags
  let f = keys.reduce((acc, k) => {
    if (store.getters.filters[(k + "").replace("tag.", "")]) {
      all[k] = store.getters.filters[(k + "").replace("tag.", "")];
    }
    if (k == "tags" && all[k] && all[k] != "-") {
      acc += `${all[k]
        .split("_or_")
        .map((a) => (a.split(" | ") || [])[0])
        .join(" ")} `;
      return acc;
    }
    if (all[k] && all[k] != "-") {
      acc += ` ${(all[k] + "").replaceAll("_or_", ", ")} `;
    }
    return acc;
  }, "");
  let tag = "";
  if (!f) {
    tag = Object.keys(all)
      .filter((k) => k.includes("tag."))
      .reduce((acc, k) => {
        if (all[k] && all[k] != "-") {
          let vs = all[k].split("_or_");
          vs.forEach((v) => {
            if (store.getters.filterLabels[v]) {
              acc.push(`${store.getters.filterLabels[v]}`);
            }
          });
        }
        return acc;
      }, [])
      .join(", ");
  }

  return tag + f + " - " + ((store.getters.store || {}).eshop || {}).name;
};
export default {
  watchQuery(newQuery, oldQuery) {
    return true;
  },
  data() {
    return {
      item: {},
      failed: false,
      ready: false,
      isBackButton: false,
      newHead: {},
    };
  },
  components: {
    Fragment,
  },
  watch: {
    "$route.fullPath": debounce(function (v) {
      if (v.includes("catalog") && v) {
        this.analysis();
         if (this.isBackButton) {
          this.isBackButton = false;
          this.$nuxt.refresh();
        }
      }
    }, 1000),
  },
  async asyncData({ app, req, params, route, commit, store, redirect, error }) {
    let preview = "";
    if (app.$cookies.get("preview")) {
      let pr = (app.$cookies.get("preview") || "").split(":::");
      if (pr[1] == store.getters.store.id) {
        preview = `&preview=${pr[0]}`;
      }
    }
    if (route.fullPath == `/${store.getters.store.eshop.catalogRoute}`) {
      redirect(301, `/catalog?q`);
    }
    let item = ((route.params || {}).path + "").split("/product/")[1];
    if (item) {
      return await itemMethod({
        req,
        app,
        params: { id: item },
        store,
        route,
        redirect,error
      });
    } else {
      let a = await dataMethod({
        app,
        req,
        route,
        commit,
        store,
        redirect,
        error,
      });
      return a;
    }
  },
  head() {
    return this.head;
  },
  mounted() {
  window.addEventListener('popstate', this.handlePopState)
    this.$nuxt.$on("headUpdate", (v) => {
      this.head = v;
    });
    this.analysis();
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.handlePopState);
  },
  methods: {
  handlePopState(event) {
    this.isBackButton = true;
  },
    analysis() {
      if (!this.$route.fullPath.includes("/product") && !this.failed) {
        setTimeout(() => {
          this.$nuxt.$emit("informant:view_item_list", {
            list_name: titleCreator(
              this.$store,
              this.$route.query,
              this.$route.params
            ),
            items: this.$store.getters.items,
          });
        }, 1000);
      } else if (
        this.$route.fullPath.includes("/product") &&
        (this.item || {}).barcode
      ) {
        setTimeout(() => {
          this.$nuxt.$emit("informant:view_item", {
            item: this.item,
          });
        }, 1000);
      }
    },
  },
  beforeRouteEnter(from, to, next) {
    if (to.name == "item-id" && process.browser) {
      (document.querySelectorAll(".type-coreHtml script") || []).forEach((e) =>
        e.remove()
      );
    }
    next();
  },
};
